export default __webpack_public_path__ + "static/media/ic_mexican.a05fc303.svg";